import { styled } from "styled-components";

export const MyPersonalColorEditWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;

  width: 383px;
`;
